import { $ } from '../lib/dom.js';
import { esc } from '../lib/escape.js';
import { RULES } from '../data/rules.js';

export function renderRules() {
  const root = $('#rules-grid');
  if (!root) return;
  RULES.forEach(r => {
    const d = document.createElement('div');
    d.className = 'rule';
    d.innerHTML = `
      <div class="n">${esc(r.n)}</div>
      <h3>${esc(r.t)}</h3>
      <p>${esc(r.p)}</p>
      <span class="stamp">▣ ${esc(r.stamp)}</span>
    `;
    root.appendChild(d);
  });
}
